import { PostApi1001, PostApi275, PostApi276 } from "../../../../modules/network/padoPost";
import { TimeListArr } from "../../Receipt/TimeList";

// export const getRsrvDrList = (userinfo, cfg, phonecfg, hpKey, setData) => {
//   PostApi275(userinfo, cfg, phonecfg, hpKey)
//     .then((res) => {
//       if (res.resultMsg === "SUCCESS") return setData(convertReturnArray(res.resultList));
//     })
//     .catch((err) => {
//       console.log(err);
//       return null;
//     });
// };

export const getRsrvDrList = (
  userinfo,
  cfg,
  phonecfg,
  hpKey,
  setData,
  startTime,
  endTime,
  appDr
) => {
  PostApi275(userinfo, cfg, phonecfg, hpKey)
    .then((res) => {
      if (res.resultMsg === "SUCCESS") {
        let returnArr = new Array();
        let workDr = [];
        let restDr = [];
        let lastArr = [];

        if (appDr == 1) {
          // returnArr = res.resultList;
          workDr = res.resultList.filter(
            (list) =>
              list.doctor[0].DrName.split(" ")[1] != "(휴진)" &&
              list.doctor[0].DrName.split(" ")[1] != "(마감)"
          );
          restDr = res.resultList.filter(
            (list) =>
              list.doctor[0].DrName.split(" ")[1] == "(휴진)" ||
              list.doctor[0].DrName.split(" ")[1] == "(마감)"
          );
        }

        if (workDr.length > 0) {
          workDr.map((m, i) => returnArr.push(m));
        }

        returnArr.push({
          doctor: [
            {
              DrName: "미지정",
              hpKey: hpKey,
              license: "미지정",
              startTime: startTime,
              endTime: endTime,
              medicalSubject: "미지정",
            },
          ],
        });

        if (restDr.length > 0) {
          restDr.map((m, i) => returnArr.push(m));
        }

        // if (appDr == "1") {
        setData(convertReturnArray(returnArr));
        // }
      }
    })
    .catch((err) => {
      console.log(err);
      return null;
    });
};

// userToken, hpKey, license, appHour, appCls
export const getRsrvTimeList = (
  userinfo,
  cfg,
  phonecfg,
  hpKey,
  license,
  appHour,
  appCls,
  setData,
  setAmpmArray,
  setTimeArray
) => {
  PostApi276(userinfo, cfg, phonecfg, hpKey, license, appHour, appCls)
    .then(res => {
      if (res.resultMsg === "SUCCESS") {
        setData(res.resultList);
        TimeListArr(res.resultList);
        setAmpmArray(res.resultList);
        // setTimeArray(res.resultList);
      }
    })
    .catch(err => {
      console.log(err);
      return null;
    });
};

const convertReturnArray = (data) => {
  let returnArray = [];
  data.map((m) =>
    returnArray.push({
      view: m.doctor[0].DrName,
      data: m.doctor[0].license,
      startHour: m.doctor[0].startTime,
      endHour: m.doctor[0].endTime,
    })
  );

  return returnArray;
};

export const getCode = (userinfo, cfg, phonecfg, grpCd, setData) => {
  PostApi1001(userinfo, cfg, phonecfg, grpCd)
    .then((res) => {
      if (res.resultMsg === "SUCCESS") {
        setData(res.result);
      }
    })
    .catch((err) => {
      console.log(err);
      return null;
    });
};
